import { decodeDriverToken } from './driverShortLink.ts';

export type DriverPathMatch =
  | { type: 'work'; token: string; canonicalPath: string }
  | { type: 'tracking'; code: string; token: string; canonicalPath: string }
  | { type: 'invalid' };

export function matchDriverLandingPath(pathname: string): DriverPathMatch {
  const value = String(pathname ?? '');
  const work = value.match(/^\/d\/([0-9a-f]{16})\/?$/i);
  if (work) {
    const token = work[1].toLowerCase();
    return { type: 'work', token, canonicalPath: `/d/${token}` };
  }

  const tracking = value.match(/^\/d\/([a-z0-9]{11})\/?$/i);
  if (tracking) {
    const token = decodeDriverToken(tracking[1]);
    if (token) {
      return { type: 'tracking', code: tracking[1], token, canonicalPath: `/d/${tracking[1]}` };
    }
  }

  return { type: 'invalid' };
}
